module.exports = __webpack_public_path__ + "static/media/logo.738a728d.svg";